<template>
  <div v-if="listData && listData.length > 0" class="filter-container" :class="{'son-filter': isSon, 'parent-filter': !isSon, 'fixed-filter': isFixed}">
    <template v-for="(item,index) in listData">
      <!-- 级联多选 -->
      <!-- <el-cascader v-if="item.type == 'cascader' && item.isShow == 1" class="filter-item" :key="index" popper-class="cascader-box"
                v-model="item[item.name]"
                :options="item.initValues"
                :props="props"
                :placeholder="item.placeholder"
                collapse-tags filterable :clearable="item.selected ? false : true"
                size="small"
                @visible-change="getOptionList($event, item)"
                @change="handleOption($event,item)"
                :style="{width:item.extra.width ? item.extra.width + 'px' : '200px'}"
            >
                <template slot-scope="{ node, data }">
                    <span>{{ data.key }}</span>
                    <span style="font-size:10px;color:#999;float:right;margin-left:30px">{{ data.value }} </span>
                </template>
            </el-cascader> -->
      <multiple-cascader
        v-if="item.type == 'cascader' && item.isShow == 1"
        ref="multipleCascaderRef"
        :key="index"
        v-model="item[item.name]"
        class="filter-item"
        :options-list="item.initValues"
        :placeholder="item.placeholder"
        size="small"
        :style="{width:item.extra.width ? item.extra.width + 'px' : '200px'}"
        :clearable="item.selected ? false : true"
        collapse-tags
        filterable
        :props="props"
        :popper-class="'cascader-box-'+item.id"
        @visible-change="getOptionList($event, item)"
        @change="handleOption($event,item)"
      />

      <!-- select 多选 -->
      <template v-if="item.type == 'multiselect'">
        <multiple-select
          :key="index"
          v-model="item[item.name]"
          class="filter-item"
          size="small"
          collapse-tags
          filterable
          :clearable="item.selected ? false : true"
          :placeholder="item.placeholder"
          :props="{label:'key', value:'value'}"
          :options-list="item.initValues"
          :loading="item.loading"
          :style="{width:item.extra.width ? item.extra.width + 'px' : '200px'}"
          @visible-change="getOptionList($event, item)"
        />

        <!-- select 后台多选 -->
        <!-- <el-select v-else class="filter-item" :key="index"
                    v-model="item[item.name]"
                    :placeholder="item.placeholder"
                    multiple collapse-tags filterable :clearable="item.selected ? false : true"
                    size="small"
                    @visible-change="getOptionList($event, item)"
                    style="width:230px;"
                >
                    <el-option v-for="(optionItem,optionIndex) in item.initValues" :key="optionIndex"
                        :label="optionItem.label"
                        :value="optionItem.value"
                        :disabled="optionItem.disabled"
                    >
                        <span style="float: left">{{ optionItem.key }}</span>
                        <span style="float: right; color: #999; font-size: 10px;margin-left:30px;margin-right:15px">{{ optionItem.value }}</span>
                    </el-option>
                </el-select> -->
      </template>

      <!-- selsect 单选 -->
      <el-select
        v-if="item.type == 'select'"
        :key="index"
        v-model="item[item.name]"
        class="filter-item"
        :placeholder="item.placeholder"
        filterable
        :clearable="item.selected ? false : true"
        size="small"
        :loading="item.loading"
        :style="{width:item.extra.width + 'px'}"
        @change="handleOption($event,item)"
        @visible-change="getOptionList($event, item)"
      >
        <el-option v-for="(optionItem,optionIndex) in item.initValues" :key="optionIndex" :label="optionItem.key" :value="optionItem.value" :disabled="optionItem.disabled">
          <span style="float: left">{{ optionItem.key }}</span>
          <span style="float: right; margin-left:20px; color: #8492a6; font-size: 12px">{{ optionItem.value }}</span>
        </el-option>
      </el-select>

      <!-- 日期 -->
      <el-date-picker
        v-if="item.type == 'daterange' || item.type == 'date' || item.type == 'monthrange'"
        :key="index"
        v-model="item[item.name]"
        unlink-panels
        class="filter-item"
        size="small"
        :value-format="item.type == 'monthrange' ? 'yyyy-MM' : 'yyyy-MM-dd'"
        :type="item.type"
        align="center"
        :clearable="item.selected ? false : true"
        :placeholder="item.type == 'date' ? item.placeholder : ''"
        :range-separator="item.type == 'daterange' || item.type == 'monthrange' ? '~' : ''"
        :start-placeholder="item.type == 'daterange' || item.type == 'monthrange' ? '开始日期' : ''"
        :end-placeholder="item.type == 'daterange' || item.type == 'monthrange' ? '结束日期' : ''"
        :picker-options="item.type == 'daterange' ? pickerDaterangeOptions : null"
        :style="{width: item.type == 'daterange' || item.type == 'monthrange' ? '260px' : '150px'}"
      />

      <!-- 时间 -->
      <el-time-select v-if="item.type == 'time'" :key="index" v-model="item[item.name]" class="filter-item" :picker-options="{ start: '00:00', step: '01:00',end: '24:00'}" :placeholder="item.placeholder" size="small" :style="{width:item.extra.width ? item.extra.width + 'px' : '150px'}" />

      <el-input v-if="item.type == 'input'" :key="index" v-model="item[item.name]" class="filter-item" :placeholder="item.placeholder" :clearable="true" size="small" :style="{width:(item.extra.width)?(item.extra.width+'px'):'200px'}" />
    </template>
    <!--  添加按钮  -->
    <!-- <el-dropdown style="float:right;margin: 10px;cursor: pointer;" trigger="click" size="small" placement="bottom-start">
      <el-button icon="el-icon-more" size="mini" plain>更多操作</el-button>
      <el-dropdown-menu slot="dropdown" class="more-dropdown">
        <el-dropdown-item @click.native="exportExcel($event)">
          <svg-icon icon-class="download" style="width: 16px;height: 16px;margin-right: 2px" />
          下载数据</el-dropdown-item>
        <el-dropdown-item @click.native="batchEdit">
          <svg-icon icon-class="edit_channel" style="width: 16px;height: 16px;margin-right: 2px" />
          批量编辑</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <!-- 保存筛选 -->
    <!-- v-if="JSON.stringify(oldParam) != JSON.stringify(newParam)" -->
    <!-- 已有筛选下拉列表 -->
    <template v-if="!sourceItem.code">
      <el-dropdown v-if="filterList.length > 0" size="small" trigger="click" placement="bottom" @command="handleCommandFilterList">
        <el-button size="small" class="filter-item default" type="" plain style="margin-right:16px;">
          <span class="button_span_style" style="margin-right:5px;display: inline-block;max-width: 60px;overflow: hidden;text-overflow: ellipsis">{{ filterForm.id ? filterList.find(item => item.id == filterForm.id).name : '常用筛选' }}</span>
          <i class="el-icon-arrow-down" />
        <!-- <svg-icon icon-class="down" style="font-size:16px;margin-right:0px;" /> -->
        </el-button>
        <el-dropdown-menu slot="dropdown" class="more-dropdown">
          <el-dropdown-item v-for="item in filterList" :key="item.id" :command="item.id" :class="{'current': filterForm.id == item.id}">
            <div style="display: flex;justify-content: space-between;">
              <div class="item-name" :title="item.name">{{ item.name }}</div>
              <div style="width: 80px;display: flex;justify-content: flex-end;align-items: center;margin-left: 20px;color: #666">
                <svg-icon icon-class="edit_tmp" style="font-size:20px" @click.stop="filterEdit(item)" />
                <svg-icon icon-class="delete" style="font-size:20px;margin-left: 8px;" @click.stop="filterDelete(item)" />
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 创建筛选或者更新另存为筛选 -->
      <el-tooltip v-if="JSON.stringify(oldParam) != JSON.stringify(newParam) && !filterForm.id && filterList.length < 5" class="item" effect="dark" content="保存为常用筛选" placement="top" popper-class="filterClass">
        <el-button size="small" class="filter-item default" type="" plain style="margin-right:16px;padding: 8px;" @click="handleCommandFilter('add')">
          <svg-icon icon-class="addFilter" title="" style="font-size:16px;margin-right:0px" />
        </el-button>
      </el-tooltip>
      <!-- <el-button v-if="JSON.stringify(oldParam) != JSON.stringify(newParam) && !filterForm.id && filterList.length < 5" size="small" class="filter-item default" type="" plain style="margin-right:16px;padding: 8px;" @click="handleCommandFilter('add')">
      <svg-icon icon-class="addFilter" title="创建筛选模板" style="font-size:16px;margin-right:0px" />
    </el-button> -->
      <el-dropdown v-if="filterForm.id" trigger="click" placement="bottom" size="small" @command="handleCommandFilter">
        <el-tooltip v-if="filterList.length == 5" class="item" effect="dark" content="常用筛选模板最多为5个，可删除模板后创建或更新已有模板" placement="top" popper-class="filterClass">
          <el-button size="small" class="filter-item default" type="" plain style="margin-right:16px;padding: 8px;">
            <svg-icon icon-class="addFilter" title="更新或另存为" style="font-size:16px;margin-right:0px" />
          </el-button>
        </el-tooltip>
        <el-button v-else size="small" class="filter-item default" type="" plain style="margin-right:16px;padding: 8px;">
          <svg-icon icon-class="addFilter" style="font-size:16px;margin-right:0px" />
        </el-button>
        <el-dropdown-menu slot="dropdown" class="more-dropdown">
          <el-dropdown-item command="update">更新模板</el-dropdown-item>
          <el-dropdown-item :disabled="filterList.length >= 5" command="saveAs">另存为</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>

    <!-- 查询按钮 -->
    <el-button class="filter-item" type="primary" size="small" :loading="loading" @click="handleFilter">查询</el-button>

    <!-- 保存 另存为 重命名 弹窗-->
    <el-dialog :title="diaType == 'add' ? '创建常用筛选模板' : diaType == 'saveAs' ? '另存为' : '重命名'" :visible.sync="filterDia" width="500px" :append-to-body="true">
      <div v-if="['add', 'saveAs'].includes(diaType)" style="margin: 0px 0px 20px 17px">常用筛选模板最多支持创建5个</div>
      <el-form ref="filterForm" :model="filterForm" label-width="148px">
        <el-form-item label="常用筛选模板名称" prop="name" :rules="[{required: true, message: diaType == 'add' ? '筛选模板名称为必填项' : '筛选模板名称为必填项', max: 10, trigger: ['blur', 'change'] }]">
          <el-input v-model="filterForm.name" maxlength="10" show-word-limit style="width: 240px" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="filterDia = false">取 消</el-button>
        <el-button type="primary" @click="handleFilterDia">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MultipleSelect from '@Sys~/components/MultipleSelect'
import MultipleCascader from '@Sys~/components/MultipleCascader'

import { productinfovalue, ajax_getTimeNode, add_filter, delete_filter, edit_filter, get_filter, update_filter } from '@Bdc~/api/ajax_model'
export default {
  components: { MultipleSelect, MultipleCascader },
  props: {
    sourceData: {
      type: Array,
      default: () => []
    },

    sourceItem: {
      type: Object || Array,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      diaType: 'add', // 弹窗类型
      filterDia: false, // 筛选条件弹窗
      filterForm: { // 筛选弹窗的表单
        filterContentJson: '',
        name: '',
        id: ''
      },
      filterList: [], // 筛选条件下拉列表
      firstLoad: true, // 是否是首次加载
      oldParam: {}, // 初始化时的默认筛选参数
      newParam: {}, // 筛选变化后的新的筛选参数
      initParam: {}, // 最原始的筛选参数
      isFixed: false,
      props: {
        multiple: true,
        expandTrigger: 'hover',
        label: 'key',
        value: 'value',
        children: 'children'
      },
      // 日期区间 日期
      shortcutsDefault: [
        {
          text: '今天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime())
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '昨天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '过去7天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '过去14天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '过去30天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '本周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            // console.log(start.getDay(), start.getDate(), 'start')
            var thisDay = start.getDay() - 1
            var thisDate = start.getDate()
            if (thisDay != 0) {
              start.setDate(thisDate - thisDay)
            }
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '上周',
          onClick(picker) {
            // 获取当前时间
            var currentDate = new Date()
            // 返回date是一周中的某一天
            var week = currentDate.getDay()
            // 返回date是一个月中的某一天
            var month = currentDate.getDate()
            // 一天的毫秒数
            var millisecond = 1000 * 60 * 60 * 24
            // 减去的天数
            var minusDay = week != 0 ? week - 1 : 6
            // 获得当前周的第一天
            var currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay))
            // 上周最后一天即本周开始的前一天
            var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond)
            // 上周的第一天
            var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6))
            var sy = priorWeekFirstDay.getFullYear()
            var sm = priorWeekFirstDay.getMonth()
            var sd = priorWeekFirstDay.getDate()
            var ey = priorWeekLastDay.getFullYear()
            var em = priorWeekLastDay.getMonth()
            var ed = priorWeekLastDay.getDate()

            var start = new Date(sy, sm, sd)
            var end = new Date(ey, em, ed)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '本月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '上月',
          onClick(picker) {
            const oDate = new Date()
            var year = oDate.getFullYear()
            var month = oDate.getMonth()
            var start, end
            if (month == 0) {
              year--
              start = new Date(year, 11, 1)
              end = new Date(year, 11, 31)
            } else {
              start = new Date(year, month - 1, 1)
              end = new Date(year, month, 0)
            }

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }
      ],
      pickerDaterangeOptions: {
        shortcuts: [],
        disabledDate(time) {
          return time.getTime() > new Date(new Date().setTime(new Date().getTime() + 3600 * 1000 * 24 * 1))
        }
      },

      listData: [],

      isSon: false // 子查询
    }
  },

  computed: {
    ...mapGetters(['transitionEnter'])
  },

  watch: {
    transitionEnter(val) {
      if (val == 1 && !this.isSon) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },

    listData: {
      handler(newValue, oldValue) {
        // console.log("对象所有属性监听", newValue, oldValue);
        // const newParam = this.structureParam()
        // console.log(newParam)
        // console.log(this.oldParam)
        // if (JSON.stringify(newParam) != JSON.stringify(this.oldParam) && !this.firstLoad) {
        //   console.log('筛选条件变了 要向上emit')
        //   this.oldParam = this.structureParam()
        // }
        this.newParam = this.structureParam()
      },
      deep: true
    }
  },

  methods: {
    // 构建listData的具体model绑定对象
    structureParam() {
      const param = {}
      this.listData.forEach(item => {
        let dataArr = []
        if (item.type == 'cascader') { // 级联多选
          item[item.name].forEach(c => {
            dataArr.push(c[c.length - 1])
          })
        } else if (item.type == 'daterange' || item.type == 'monthrange') { // 时间区间
          dataArr = item[item.name][0] + ' - ' + item[item.name][1]
        } else {
          dataArr = item[item.name]
          // console.log('====1111',item,item[item.name], item.name)
        }
        param[item.name] = dataArr ? dataArr.toString() : ''
      })
      return JSON.parse(JSON.stringify(param))
    },

    // 初始化数据
    init(val) {
      if (val == 'son') {
        this.isSon = true
      } else {
        this.isSon = false
      }
      this.pickerDaterangeOptions.shortcuts = this.shortcutsDefault

      this.getTimeNode()

      this.listData = JSON.parse(JSON.stringify(this.sourceData))

      // 获取已保存的常用筛选
      this.getFilterList()

      let isPass = true // 可以查询

      const promiseArr = []

      this.listData.map(v => {
        if (v.initQuery == 0 && v.initValues && v.initValues.length > 0) { // 不请求接口 并 有初始值
          if (v.type == 'daterange' || v.type == 'monthrange') { // 初始化时间范围
            const arrDate = v.initValues[0].value.split(' ')
            // console.log(arrDate)
            const value = [arrDate[0], arrDate[arrDate.length - 1]]
            this.$set(v, v.name, value)
          } else if (v.type == 'multiselect' || v.type == 'cascader') {
            this.$set(v, v.name, [v.initValues[0].value])
          } else {
            this.$set(v, v.name, v.initValues[0].value)
          }
        } else if (v.initQuery == 1 && v.selected) { // 需请求接口 有初始值
          isPass = false
          promiseArr.push(this.getOptionList(true, v, () => {
            if (v.type == 'select') {
              this.$set(v, v.name, v.initValues[0].value)
            } else {
              this.$set(v, v.name, [v.initValues[0].value])
            }

            this.handleFilter() // 查询
          }))
        } else { // 请求接口，没有初始值
          if (v.type == 'select') {
            // console.log('走这===', v.name, v.placeholder)
            this.$set(v, v.name, '')
          } else if (v.type == 'input') {
            this.$set(v, v.name, '')
          } else {
            this.$set(v, v.name, [])
          }

          this.$set(v, 'loading', true)
        }

        if (v.name == 'header_app_channel_code' || v.name == 'app_channel_code') { // 运营渠道
          this.$set(v, 'isShow', 0)
          this.$set(v, v.relationName, [])
        } else if (v.relationName) { // 根据其他选项 获取列表
          this.sourceData.forEach(item => {
            const relationName = v.relationName.split(',')
            if (relationName.indexOf(item.name) > -1) {
              if (item.initValues && item.initValues.length > 0) {
                relationName.forEach(m => {
                  if (m == item.name) {
                    if (item.type == 'select') {
                      this.$set(v, m, item.initValues[0].value)
                    } else {
                      this.$set(v, m, [item.initValues[0].value])
                    }
                  }
                })
              } else {
                relationName.forEach(m => {
                  if (m == item.name) {
                    if (item.type == 'select') {
                      this.$set(v, m, '')
                    } else if (item.type == 'input') {
                      this.$set(v, m, '')
                    } else {
                      this.$set(v, m, [])
                    }
                  }
                })
              }
            }
          })
        } else {
          this.$set(v, 'isShow', 1)
        }

        return v
      })

      this.$nextTick(() => {
        if (isPass) {
          this.handleFilter() // 查询
        }

        if (!this.isSon && this.transitionEnter == 0) {
          this.isFixed = true
          this.$nextTick(() => {
            this.$emit('initCallback')
          })
        }

        // 有些筛选 要先调用接口 获得下拉之后才完事 其中会有操作获取下拉后拿第一条赋值给listData中的筛选数据 所以要等这些借口完事之后才能构建oldParam
        Promise.all(promiseArr).then(res => {
          this.oldParam = this.structureParam()
          this.newParam = this.structureParam()
          this.initParam = this.getOrSetListDataModel()
          this.firstLoad = false
        })
      })
    },

    // 获取筛选条件列表
    getOptionList(val, item, callback) {
      return new Promise((resolve, reject) => {
      // console.log(val)
        if (val && item.initQuery == 1) {
        // console.log(item)
          let parameter = ''
          if (item.relationName) {
            const relationName = item.relationName.split(',')
            relationName.forEach(v => {
              parameter = parameter + '&' + v + '=' + item[v]
            })
          }
          productinfovalue(item.name, parameter).then(response => {
            if (response.code == 1) {
              item.loading = false
              item.initValues = response.data
              if (callback) {
                callback()
              }
              resolve(response.data)
            }
          })
        }
      })
    },

    // 监听选项值改变
    handleOption(val, item) {
      if (item.name == 'header_channel_code' || item.name == 'channel_code') {
        // 注册渠道
        if (val.length == 1) {
          this.listData.forEach(v => {
            if (v.name == 'header_app_channel_code' || v.name == 'app_channel_code') { // 运营渠道
              v.isShow = 1
              v[v.relationName] = val[0][val[0].length - 1]
            }
          })
        } else {
          this.listData.forEach(v => {
            if (v.name == 'header_app_channel_code' || v.name == 'app_channel_code') { // 运营渠道
              v.isShow = 0
              v[v.relationName] = []
              v[v.name] = []
              v.initValues = []
            }
          })
        }
      } else {
        this.listData.forEach(v => {
          if (v.relationName) {
            const relationName = v.relationName.split(',')
            if (relationName.indexOf(item.name) > -1) {
              relationName.forEach(m => {
                if (m == item.name) {
                  v[m] = item[item.name]
                }
              })

              if (v.type == 'select') {
                v[v.name] = ''
              } else {
                v[v.name] = []
              }
              v.initValues = []
            }
          }
        })
      }
    },

    // 查询
    handleFilter() {
      // console.log('查询===333',this.listData, this.isSon)
      const resultData = {}
      this.listData.forEach(item => {
        let dataArr = []
        if (item.type == 'cascader') { // 级联多选
          item[item.name].forEach(c => {
            dataArr.push(c[c.length - 1])
          })
        } else if (item.type == 'daterange' || item.type == 'monthrange') { // 时间区间
          dataArr = item[item.name][0] + ' - ' + item[item.name][1]
        } else {
          dataArr = item[item.name]
          // console.log('====1111',item,item[item.name], item.name)
        }

        this.$nextTick(() => {
          // console.log('===2222',item)
          resultData[item.name] = dataArr.toString()
        })
      })

      if (this.isSon) {
        // console.log('筛选条件子====：',resultData)
        this.$emit('onSonFilter', resultData)
      } else {
        // console.log('筛选条件：',resultData)
        this.$emit('onFilter', resultData)
      }
    },

    // 获取listData的基础model数据 或者根据已有筛选往listData塞model数据
    getOrSetListDataModel(data) {
      if (data) {
        // 如果是应用筛选的情况 要先给header_channel_code赋值 因为header_channel_code值的改变会联动其他组件是否显示并且可能导致其他组件值置空 当header_channel_code数据以及页面处理完之后 再对其他数据进行赋值等处理
        if (data['header_channel_code'].length) {
          const header_channel_code = this.listData.find(item => item.name == 'header_channel_code')
          this.$set(header_channel_code, 'header_channel_code', data['header_channel_code'])
        }
        this.$nextTick(() => {
          this.$refs.multipleCascaderRef[0].handleVisible(true)
        })
        // 这时候header_channel_code组件已经完善了 下面对header_channel_code也不会触发change事件 就可以对其他选项赋值了
        setTimeout(() => {
          this.listData.forEach(item => {
            this.$set(item, item.name, data[item.name])
          })
          this.$refs.multipleCascaderRef[1] && this.$refs.multipleCascaderRef[1].handleVisible(true)
        })
        console.log(JSON.parse(JSON.stringify(this.listData)))
      } else {
        const param = {}
        this.listData.forEach(item => {
          param[item.name] = item[item.name]
        })
        return JSON.stringify(param)
      }
    },

    // 保存or更新按钮
    handleCommandFilter(e) {
      console.log(this.newParam)
      this.filterForm.filterContentJson = this.getOrSetListDataModel()
      this.filterForm.name = ''
      if (e == 'add') {
        this.diaType = 'add'
        this.filterDia = true
      } else if (e == 'update') {
        update_filter({ id: this.filterForm.id, menuId: this.$store.getters.currentRoute.meta.id, filterContentJson: this.filterForm.filterContentJson }).then(res => {
          if (res.code == 1) {
            this.$message.success('更新成功！')
            this.getFilterList()
          }
        })
      } else if (e == 'saveAs') {
        this.diaType = 'saveAs'
        this.filterDia = true
      }
      this.$nextTick(() => {
        this.$refs.filterForm && this.$refs.filterForm.clearValidate()
      })
    },

    // 筛选弹窗确定
    handleFilterDia() {
      console.log(this.diaType)
      this.$refs.filterForm.validate(valid => {
        console.log('保存 另存为 重命名    重命名用editId  另存为用id')
        console.log(this.diaType)
        if (valid) {
          if (this.diaType == 'add') {
            add_filter({ name: this.filterForm.name, menuId: this.$store.getters.currentRoute.meta.id, filterContentJson: this.filterForm.filterContentJson }).then(async res => {
              if (res.code == 1) {
                this.$message.success('创建成功,可在常用筛选中查看！')
                await this.getFilterList()
                this.filterForm.id = res.data
                this.filterDia = false
              }
            })
          } else if (this.diaType == 'edit') {
            edit_filter({ id: this.filterForm.editId, name: this.filterForm.name, menuId: this.$store.getters.currentRoute.meta.id, filterContentJson: this.filterForm.filterContentJson }).then(res => {
              if (res.code == 1) {
                this.$message.success('保存成功！')
                this.filterDia = false
                this.getFilterList()
              }
            })
          } else if (this.diaType == 'saveAs') {
            add_filter({ name: this.filterForm.name, menuId: this.$store.getters.currentRoute.meta.id, filterContentJson: this.filterForm.filterContentJson }).then(async res => {
              if (res.code == 1) {
                this.$message.success('另存为成功！')
                await this.getFilterList()
                this.filterForm.id = res.data
                this.filterDia = false
              }
            })
          }
        }
      })
    },

    // 选择已有筛选
    handleCommandFilterList(id) {
      console.log(id)
      this.filterForm.id = id
      const filter = this.filterList.find(item => item.id == id)
      this.getOrSetListDataModel(JSON.parse(filter.filterContentJson))
    },

    // 已有筛选删除
    filterDelete(item) {
      console.log(item)
      this.$confirm('是否确认删除常用筛选模板：' + item.name + '？', '删除常用筛选', {
        customClass: 'delete-message',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delete_filter(item.id).then(res => {
          if (res.code == 1) {
            this.$message.success('删除成功！')
            this.getFilterList()
            // 如果删除的是当前正在使用的筛选 那么就要把filterForm的id清空 否则会有误操作更新的可能
            if (this.filterForm.id == item.id) {
              this.filterForm.id = ''
            }
            if (this.filterList.length == 1) {
              this.getOrSetListDataModel(JSON.parse(this.initParam))
            }
          }
        })
      }).catch((err) => { })
    },

    // 已有筛选重命名
    filterEdit(item) {
      console.log(item)
      this.diaType = 'edit'
      this.filterDia = true
      this.filterForm.editId = item.id
      this.filterForm.name = item.name
      this.$refs.filterForm && this.$refs.filterForm.clearValidate()
    },

    // 获取已保存的常用筛选
    getFilterList() {
      return new Promise((resolve) => {
        get_filter(this.$store.getters.currentRoute.meta.id).then(res => {
          if (res.code == 1) {
            this.filterList = res.data

            // 142行到149行的dropdown会有 if else 的情况 必须要重新渲染el-dropdown组件 不然会失效 所以对id置空再置回来 可以达到重新渲染的目的
            this.filterForm.tmpId = this.filterForm.id
            this.filterForm.id = ''
            this.$nextTick(() => {
              this.filterForm.id = this.filterForm.tmpId
            })
            resolve()
          }
        })
      })
      // this.filterList = [{ name: '筛选1', id: 1, filterContentJson: '{"header_channel_code":[["16","850"],["16","1901"]],"header_app_channel_code":[],"header_server_code":["126"],"header_query_time":"2023-11-05","header_query_type":"1","header_moneyunit":"CNY"}' }, { name: '筛选2', id: 2 }]
    },

    // 查询时间节点
    getTimeNode() {
      ajax_getTimeNode().then(response => {
        if (response.code == 1) {
          this.pickerDaterangeOptions.shortcuts = [
            {
              text: '今天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime())
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '过去7天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '过去14天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
                end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '过去30天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '本周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                // console.log(start.getDay(), start.getDate(), 'start')
                var thisDay = start.getDay() - 1
                var thisDate = start.getDate()
                if (thisDay != 0) {
                  start.setDate(thisDate - thisDay)
                }
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '上周',
              onClick(picker) {
                // 获取当前时间
                var currentDate = new Date()
                // 返回date是一周中的某一天
                var week = currentDate.getDay()
                // 返回date是一个月中的某一天
                var month = currentDate.getDate()
                // 一天的毫秒数
                var millisecond = 1000 * 60 * 60 * 24
                // 减去的天数
                var minusDay = week != 0 ? week - 1 : 6
                // 获得当前周的第一天
                var currentWeekDayOne = new Date(currentDate.getTime() - (millisecond * minusDay))
                // 上周最后一天即本周开始的前一天
                var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - millisecond)
                // 上周的第一天
                var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (millisecond * 6))
                var sy = priorWeekFirstDay.getFullYear()
                var sm = priorWeekFirstDay.getMonth()
                var sd = priorWeekFirstDay.getDate()
                var ey = priorWeekLastDay.getFullYear()
                var em = priorWeekLastDay.getMonth()
                var ed = priorWeekLastDay.getDate()

                var start = new Date(sy, sm, sd)
                var end = new Date(ey, em, ed)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '本月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setDate(1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '上月',
              onClick(picker) {
                const oDate = new Date()
                var year = oDate.getFullYear()
                var month = oDate.getMonth()
                var start, end
                if (month == 0) {
                  year--
                  start = new Date(year, 11, 1)
                  end = new Date(year, 11, 31)
                } else {
                  start = new Date(year, month - 1, 1)
                  end = new Date(year, month, 0)
                }

                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }
          ]
          response.data.forEach(item => {
            if (item.stageName == '上线至今') {
              item.endTime = new Date().Format('yyyy-MM-dd')
            }
            this.pickerDaterangeOptions.shortcuts.push({
              text: item.stageName,
              onClick(picker) {
                picker.$emit('pick', [item.startTime, item.endTime])
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.filter-container {
  text-align: left;

  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 68%;
    }
    .el-select__input {
      margin-left: 2px;
    }
  }

  ::v-deep .el-cascader__tags {
    .el-tag {
      max-width: 58%;
    }
    .el-cascader__search-input {
      margin: 2px 0 2px 5px;
      min-width: 3%;
    }
  }
}

// 子筛选
.son-filter {
  padding: 0;
}

// 父筛选
.parent-filter {
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

  padding: 10px 16px 0;

  transition: width 0.18s;
}

// 固定筛选
.fixed-filter {
  position: fixed;
  top: 84px;
  // left: #{$sideBarWidth};
  z-index: 8;
  width: calc(100% - #{$sideBarWidth});
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

  padding: 10px 26px 0 16px;

  transition: width 0.18s;
}

.hideSidebar {
  .fixed-filter {
    width: calc(100% - 54px);
  }
}
.mobile {
  .fixed-filter {
    width: 100%;
  }
}
.more-dropdown{
  margin-top: -8px!important;
  border-radius: 8px;
  ::v-deep .popper__arrow {
    display: none;
  }
  ::v-deep .el-dropdown-menu__item{
    padding: 2px 20px;
    &.current {
      background-color: #ebf3ff;
      color: #61a1ff!important;
    }
  }
  ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus{
    background: #EBF3FF;
    color: #333333;
  }
  svg :hover{
    color: #3A89FF;
  }
}
</style>

<style lang="scss">
.cascader-box {
  .el-cascader-menu__wrap {
    height: 300px;
  }
}
.delete-message{
  .el-message-box__header{
    padding-top: 24px;
    font-weight: 600;
  }
  .el-message-box__content{
    padding: 16px;
    .el-message-box__message{
      font-size: 16px;
      color: #333333;
    }
    .el-message-box__status{
      top: 12px;
    }
  }
  .el-message-box__btns{
    padding: 24px 24px 20px 24px;
    .el-button{
      padding: 10px 20px;
      font-size: 14px;
      border-radius: 4px;
    }
  }
}
</style>

